import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import {BsShopWindow} from 'react-icons/bs'
import {BiCameraMovie} from 'react-icons/bi'
import {AiOutlineInfoCircle} from 'react-icons/ai'
import ContactModal from './modals/ContactModal';
import ProductsModal from './modals/ProductsModal';
import InfoModal from './modals/InfoModal';
import Wrapper from '../Home/homeWrapper/Wrapper';
import { useDispatch, useSelector } from 'react-redux';
import MainLoading from '../utils/MainLoading';
import default_image_url from '../redux/api/API';
import { fetchExpoSaDetailloon } from '../redux/action/saloons/saloon-detail';
import './style.scss'

const SaloonExhibition = (props) => {
    const [show, setShow] = useState(true);
    const [id, setId] = useState(true);

    const [modal, setModal] = useState({
        info: false,
        contact: false,
        products: false
    })
    const dispatch = useDispatch()
    const saloon = useSelector(state => state.saloon_detail)

    useEffect(() => {
        dispatch(fetchExpoSaDetailloon(props.match.params.id))
    }, [])

    const handleContact = (id) => { {
        setModal({ contact: true })
        setShow(true)
        setId(id);
    }}

    const handleInfo = (id) => { {
        setModal({ info: true })
        setShow(true)
        setId(id);
    }}

    const handleProducts = (id) => { {
        setModal({ products: true })
        setShow(true)
        setId(id);
    }}

    const close = () => {
        setShow(false)
    }

    const handleReturn = () => {
        props.history.replace('/exhibition')
    }

    const settings = {
        dots: false,
        infinite: true,
        arrow: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

  return (
    <>
    <Wrapper>
        {saloon.loading ?
            <MainLoading />
        :
            <>
            <div className='mobile_message'>لطفا گوشی را بصورت افقی نگه دارید</div>
            <div className='expo_company_page'>
                <button className='btn btn-danger return_to_expo' onClick={handleReturn}> بازگشت به نمایشگاه </button>
                {saloon.saloon_detail.users && saloon.saloon_detail.users.length ? 
                    <Slider {...settings}>
                        {saloon.saloon_detail.users.map(company => (
                            <div className='expo_comapny' key={company.id}>
                                <Link to={`/company/${company.id}`} target="_blank" className='expo_title'>{company.title}</Link>
                                <div className='expo_products_modal' onClick={() => handleProducts(company.id)}><BsShopWindow /></div>
                                <div className='expo_contact' onClick={() => handleContact(company.id)}><BiCameraMovie /></div>
                                <div className='expo_info' onClick={() => handleInfo(company.id)}><AiOutlineInfoCircle /></div>
                                <div className='expo_banner'>
                                    <div className='expo_banner_logo'>
                                        {company.avatar ?
                                            <img src={default_image_url+company.avatar} alt={company.title} />
                                        :
                                            <img src='/assets/img/shop.png' alt={company.title} />
                                        }
                                    </div>
                                    {company.description ?  
                                        <p>{company.description}</p> 
                                    :
                                        <p className='text-center'> غرفه شرکت کننده در نمایشگاه مجازی </p>
                                    }
                                </div>
                            </div>
                        ))}
                    </Slider>
                :
                    <h5 className='py-5 text-center'>برای این سالن غرفه ای ایجاد نشده است</h5>
                }
            </div>
            </>
        }
    </Wrapper>

    {modal.contact && <ContactModal show={show} id={id} close={close} />}
    {modal.info && <InfoModal show={show} id={id} close={close} />}
    {modal.products && <ProductsModal show={show} id={id} close={close} />}

    </>
  )
}

export default SaloonExhibition;
